/* eslint-disable @typescript-eslint/no-magic-numbers */
export enum RippleSizesValue {
  small = 20,
  medium = 50,
  large = 70,
  extraLarge = 200,
}
